import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Avatar, Button } from "@mui/material";
import { useNavigate } from "react-router";
import styles from "./WaitingSteps.module.scss";
import { Link } from "react-router-dom";

const WaitingDraftApproval: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box className={styles.waiting}>
      <h2>{t("pendingFinalDraftApproval")}</h2>
      <ul>
        <li>
          <p>
            {t("pendingFinalDraftApprovalMessages.0")} <em>{t("pendingFinalDraftApprovalMessages.1")}</em>
          </p>
        </li>
        <li>
          <p>{t("pendingFinalDraftApprovalMessages.2")}</p>
        </li>
        <li>
          <p>{t("pendingFinalDraftApprovalMessages.3")}</p>
        </li>
      </ul>
      <p className={styles.orange}>{t("waitingApprovalText")}</p>
      <Avatar>
        <MailOutlineIcon />
      </Avatar>
      <p>
        {t("youCanContinueWithThisWorkflowInTheFuture")}
        <Link to={"/myinbox"}>{t("myPublications")}</Link>
      </p>
      <Button variant="text" onClick={() => navigate("/")}>
        {t("backToHome")}
      </Button>
    </Box>
  );
};

export default WaitingDraftApproval;
